<template>
  <div class="entrubanfrom_fluid">
    <div class="entrubanfrom flex_end">
      <div class="from">
        <div class="fromitem flex_start">
          <div class="labe">称呼</div>
          <div class="labemh">:</div>
          <div>
            <input type="text" placeholder="输入名称，方便我们称呼您" />
          </div>
        </div>
        <div class="fromitem flex_start">
          <div class="labe">手机号</div>
          <div class="labemh">:</div>
          <div><input type="text" placeholder="请输入正确的手机号码" /></div>
        </div>

        <div class="fromitem flex_start">
          <div class="labe">标题</div>
          <div class="labemh">:</div>
          <div>
            <input type="text" placeholder="如：找擅长婚姻家庭的律师" />
          </div>
        </div>

        <div class="fromitem flex_start">
          <div class="labe">描述</div>
          <div class="labemh">:</div>
          <div>
            <textarea
              placeholder="请详细描述案件情况及想获得律师什么帮助"
            ></textarea>
          </div>
        </div>

        <div class="fromitem"><div class="submit">免费发布</div></div>

        <div class="frombottom between">
          <div>如何发布案件委托？</div>
          <div>什么是案件委托？</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scope>
.entrubanfrom_fluid {
  width: 1920px;
  height: 520px;
  margin: 0 auto;
  background: url("../../../assets/entrust/entrust_banner_bg.png");
  padding: 40px 0;
  .entrubanfrom {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    .from {
      width: 560px;
      height: 440px;
      padding: 20px 30px;
      background: #ffffff;
      color: #666666;
      box-shadow: 0px 1px 13px 0px rgba(58, 73, 210, 0.2);
      .fromitem {
        align-items: flex-start;
        margin-top: 18px;
        .labe {
          padding-top: 10px;
          width: 55px;
          text-align-last: justify;
          text-align: justify;
        }
        .labemh {
          padding-top: 10px;
          margin: 0 30px 0 10px;
        }
        .submit {
          width: 204px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          margin: 0 auto;
          background: #f25618;
          box-shadow: 0px 1px 10px 0px rgba(173, 0, 2, 0.15);
          border-radius: 5px;
          font-size: 24px;
          color: #ffffff;
          cursor: pointer;
        }
        input {
          width: 390px;
          height: 40px;
          line-height: 40px;
          padding-left: 16px;
          border: 1px solid #dddddd;
        }
        input::-webkit-input-placeholder,
        textarea::-webkit-input-placeholder {
          color: #bbbbbb;
        }
        input:focus,
        textarea:focus {
          outline: none;
        }
        textarea {
          width: 390px;
          height: 80px;
          padding-top: 10px;
          line-height: 20px;
          padding-left: 16px;
          border: 1px solid #dddddd;
        }
      }
      .frombottom {
        margin-top: 40px;
        div {
          cursor: pointer;
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }
}
</style>